import { createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../utils/request';
import { METHOD_POST } from '../../constants/api';

const getListings = createAsyncThunk('listings/getListings',
  async (refresh, { rejectWithValue, getState }) => {
    try {
      const filter = getState()?.listingsFilter;
      const data = await authSet(METHOD_POST, '/listings', filter);
      return { ...data, refresh: !refresh };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default getListings;
